import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export function GeneralError() {
    const modalTitle = <Typography>Seite nicht verfügbar</Typography>;
    const modalContent = (
        <ContentTypography>
            Hoppla! Diese Seite hat wohl ihre Reiseroute geändert.
        </ContentTypography>
    );
    return { modalTitle, modalContent, autoClosingModal: true };
}
